import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '@store/config';
import { Book } from '@api/types.generated';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/book');

export const fetchBookList = actionCreator.async<{}, Book[]>('BOOK_LIST');
export const createBook = actionCreator.async<Omit<Book, 'id' | 'authors'> & { authors: string[] }, {}>(
  'BOOK_CREATE',
);
export const deleteBook = actionCreator.async<Book['id'], {}>('BOOK_DELETE');
export const updateBook = actionCreator.async<Omit<Book, 'authors'> & { authors: string[] }, Book>('BOOK_UPDATE');
